import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

import { CreateOrderModal } from '@/components/modals/CreateOrderModal';
import OrdersTable from './ordersTable';

export function OrderManage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleOrderCreated = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="flex flex-col h-[calc(100vh-8rem)]">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold mb-1">Order Management</h1>
          <p className="text-muted-foreground">Track and manage all customer orders.</p>
        </div>
        <Button
          onClick={() => setIsModalOpen(true)}
          className="bg-primary text-primary-foreground hover:bg-primary/90"
        >
          <Plus className="h-4 w-4 mr-2" />
          Create Order
        </Button>
      </div>
      <OrdersTable refreshTrigger={refreshTrigger} />
      <CreateOrderModal open={isModalOpen} onOpenChange={setIsModalOpen} onOrderCreated={handleOrderCreated} />
    </div>
  );
}
